module.exports = __webpack_public_path__ + "static/media/hotel-512.62948121.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hotel-512.png
// module id = 771
// module chunks = 0